'use client';
import React from 'react';
import { useTranslations } from 'next-intl';
import { CatIconProp65, CatTextPassage } from 'components/blocks-components';
import cx from 'classnames';
import { prop65WarningMsg } from 'components/product-quick-view-drawer/utils';

export interface Prop65WarningProps {
  prop65?: string;
  isMobile?: boolean;
  isPCC_PDP_headerUpdateMobileView?: boolean;
}

const Prop65Warning = ({
  prop65,
  isMobile,
  isPCC_PDP_headerUpdateMobileView
}: Prop65WarningProps) => {
  const t = useTranslations();
  return (
    <div
      className={cx('d-flex cat-u-theme-typography-footnote mb-2', {
        'mb-4': isMobile && isPCC_PDP_headerUpdateMobileView
      })}
    >
      <CatIconProp65 className="me-2" />
      <div className="m-0">
        <CatTextPassage size="xs">
          <b className="text-uppercase">{t('INACTIVITY_WARNING_DIALOG_WARNING_ICON')}:</b>
          <span
            className="cat-u-padding-left-sm"
            dangerouslySetInnerHTML={{
              __html: prop65WarningMsg(prop65)
            }}
          />
        </CatTextPassage>
      </div>
    </div>
  );
};

export default Prop65Warning;
